import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Problem", href: "#problem" },
    { label: "What We Do", href: "#what-we-do" },
    { label: "Free Guide", href: "#guide" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl border-b border-[#E5E5E5]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-brand"
          className="flex items-center gap-2 group"
        >
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-[#0A0A0A] text-white font-extrabold text-sm tracking-tight">
            O
          </span>
          <span className="text-[#0A0A0A] font-extrabold tracking-tight text-lg">
            OperatorAI
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-[#525252] hover:text-[#0A0A0A] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex">
          <a
            href="#guide"
            data-testid="nav-cta-button"
            className="inline-flex items-center gap-2 bg-[#0052FF] hover:bg-[#0040CC] text-white text-sm font-semibold py-2.5 px-4 rounded-lg transition-colors shadow-sm shadow-[#0052FF]/20 focus:outline-none focus:ring-2 focus:ring-[#0052FF] focus:ring-offset-2"
          >
            Get the Free Guide
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-md text-[#0A0A0A] hover:bg-[#FAFAFA] transition-colors"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white border-t border-[#E5E5E5]"
        >
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-[#0A0A0A]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#guide"
              data-testid="mobile-nav-cta"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center bg-[#0052FF] hover:bg-[#0040CC] text-white text-sm font-semibold py-3 px-4 rounded-lg transition-colors"
            >
              Get the Free Guide
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
